import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import {
    CheckOutQuestion,
    CheckOutQuestionKey
} from '../../models/check-out-question';

const getCheckOutQuestionIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<CheckOutQuestion>) => memoize((
        appointmentId: Undefinable<number>
    ) => Object
        .keys(byId)
        .filter(x => appointmentId === byId[x]!.appointmentId)
        .map(x => +x)
    )
);

const getCurrentCheckOutQuestionKeySelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<CheckOutQuestion>) => memoize((
        appointmentId: Undefinable<number>
    ) => {
        const checkOutQuestionId = Object
            .keys(byId)
            .filter(x => appointmentId === byId[x]!.appointmentId)
            .sort((a, b) => Number(a) - Number(b))
            .slice(-1)[0];
        return byId[checkOutQuestionId || ''] && byId[checkOutQuestionId || '']!.questionKey;
    })
);

export const selectors = {
    getCheckOutQuestion: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<CheckOutQuestion> => state.byId[id || ''],
    getCheckOutQuestionIds: (
        state: State,
        appointmentId: Undefinable<number>
    ): number[] => getCheckOutQuestionIdsSelector(state)(appointmentId),
    getCurrentCheckOutQuestionKey: (
        state: State,
        appointmentId: Undefinable<number>
    ): Undefinable<CheckOutQuestionKey> => getCurrentCheckOutQuestionKeySelector(state)(appointmentId),
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false
};
